var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcConditionCheckCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#148740"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_63540)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "translate(4 4)",
    fill: "#148740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45046 8.49237L4.45047 8.49239L6.46998 10.4982C6.47002 10.4982 6.47005 10.4983 6.47009 10.4983C6.61405 10.6423 6.8041 10.7135 6.99162 10.7135C7.18006 10.7135 7.36922 10.6422 7.51314 10.4983C7.51318 10.4983 7.51322 10.4982 7.51326 10.4982L11.5508 6.4863C11.8395 6.1995 11.8395 5.73513 11.5508 5.44833C11.2626 5.16189 10.7963 5.16188 10.508 5.44832C10.508 5.44833 10.508 5.44833 10.508 5.44833L6.99159 8.9416L5.49326 7.45441C5.49325 7.45439 5.49323 7.45438 5.49322 7.45437C5.20494 7.16796 4.73873 7.16797 4.45046 7.45441C4.16183 7.7412 4.16183 8.20558 4.45046 8.49237Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_63540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConditionCheckCorrect);
export default __webpack_public_path__ + "static/media/ic_condition-check-correct.41e2f71c0c06f78b6a48b869700519c7.svg";
export { ForwardRef as ReactComponent };